/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, breakpoints, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const rcGoogleSetupContainerBase = (theme: Theme) =>
  css({
    paddingBottom: 'var(--cds-spacing-400)',
  });

const banner = (theme: Theme) =>
  css({
    background: 'var(--cds-color-blue-700)',
    paddingTop: '56px',
    paddingBottom: '100px',
    [breakpoints.down('sm')]: {
      padding: 'var(--cds-spacing-600) var(--cds-spacing-200)',
      fontSize: '36px',
    },
    [breakpoints.down('xs')]: {
      padding: 'var(--cds-spacing-400) var(--cds-spacing-200)',
      fontSize: '36px',
    },
  });

const bannerTitleTextContainer = css({
  width: '936px',
  margin: '0 auto',
});

const bannerTitleText = (theme: Theme) =>
  css({
    color: 'var(--cds-color-white-0)',
    '&&': {
      lineHeight: '42px',
      fontSize: '34px',
      fontWeight: 600,
    },
  });

const contentContainer = (theme: Theme) =>
  css({
    padding: 'var(--cds-spacing-400) var(--cds-spacing-800)',
    width: '936px',
    position: 'relative',
    top: '-35px',
    margin: '0 auto',
    background: 'var(--cds-color-white-0)',
    border: `1px solid var(--cds-color-grey-50)`,
    [breakpoints.down('sm')]: {
      top: '0',
      padding: 'var(--cds-spacing-300)',
      width: '100%',
    },
  });

export type Props = {
  title: string;
};

const GoogleSetupContainerBase: React.LegacyFunctionComponentWithChildren<Props> = ({ title, children }) => {
  const theme = useTheme();
  return (
    <div css={rcGoogleSetupContainerBase(theme)} data-test-id="google-setup-container-base">
      <div css={banner(theme)}>
        <div css={bannerTitleTextContainer}>
          <Typography variant="h1" color="invertBody" css={bannerTitleText(theme)}>
            {title}
          </Typography>
        </div>
      </div>
      <div css={contentContainer}>{children}</div>
    </div>
  );
};

export default GoogleSetupContainerBase;
